import { RadioTile, TileGroup, Tooltip } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { QuesIDProps } from '../../Maas360Estimator';
import { segmentsTracking } from 'src/common/lib/tracker';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';

type Step5Props = {
  que5Value: string;
  setQue5Value: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  trackQuesID: QuesIDProps;
  setShowTopMatch: React.Dispatch<React.SetStateAction<boolean>>;
  useTranslation: TranslationFunction;
};

const Step5 = ({
  que5Value,
  setQue5Value,
  setIsRequired,
  setTrackQuesID,
  trackQuesID,
  setShowTopMatch,
  useTranslation,
}: Step5Props) => {
  const yes = convertToString(useTranslation('yes', true));
  const no = convertToString(useTranslation('no', true));

  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
  ) => {
    setQue5Value(value);
    setIsRequired(false);
    setTrackQuesID({
      ...trackQuesID,
      Q5: (event.target as HTMLInputElement).id,
    });
    setShowTopMatch(true);
    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: `question 5 - ${value} - selected`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  useEffect(() => {
    if (que5Value) {
      setIsRequired(false);
    }
  }, []);

  return (
    <div>
      <div className="page_sub_heading padding_8">
        {useTranslation('que5_text_desc')}
        <Tooltip
          className="maas360_widget__maas360-tooltip"
          onChange={() => {
            // For segment tracking
            segmentsTracking('CTA Clicked', {
              pageTitle: 'MaaS360 Plan Assessment',
              object: 'Mass360 page',
              resultValue: 'CTA clicked',
              CTA: `question 5 - tooltip`,
              location: 'Assessment',
              action: '',
              field: '',
            });
          }}
          direction="right"
          tabIndex={0}
        >
          <span className="slide_text">
            {useTranslation('que5_text_tooltip')}
          </span>
        </Tooltip>
      </div>
      <TileGroup
        name="radio-group"
        className="tilegroup"
        valueSelected={que5Value}
      >
        <RadioTile
          className="tile"
          id="Q5A1"
          value="Yes"
          onClick={(e) => handleClick(yes, e)}
        >
          {useTranslation('yes')}
        </RadioTile>
        <RadioTile
          className="tile"
          id="Q5A2"
          value="No"
          onClick={(e) => handleClick(no, e)}
        >
          {useTranslation('no')}
        </RadioTile>
      </TileGroup>
    </div>
  );
};

export default Step5;
